import { createStore } from "vuex";
import { auth } from "./auth.module";
import { transaction } from "./transaction.module";
import { balance } from "./balance.module";

const store = createStore({
  modules: {
    auth,
    transaction,
    balance
  },
});

export default store;
